/* The registered entry point for the 3D network view.
 *
 * Viewpoint mode only, like the four XYZ charts - and here the reason is sharper than it is for
 * them. This view draws the loaded graph: `scopeComponentIds`, `scopeReferenceIds` and the
 * parent/child structure between them. That is what a traversal produces. Workspace mode has no
 * equivalent to read, so there is nothing to adapt onto rather than a second path to write. */

import { ViewIds } from '@ardoq/api-types';
import { connect } from '@ardoq/rxbeach';
import styled from 'styled-components';
import { toViewpointModeMainViewInstanceId } from 'appLayout/mainViewInstanceIds';
import { getViewpointModeViewSettingsWithChanges$ } from 'views/environmentals/viewSettings/viewpointModeViewSettings$';
import { Network3DView } from './Network3DView';
import { network3dViewModel$ } from './viewModel$/network3dViewModel$';

const VIEW_ID = ViewIds.NETWORK_3D;
const VIEW_INSTANCE_ID = toViewpointModeMainViewInstanceId(VIEW_ID);

/** See `Surface3DViewController` for why this grows rather than sets a height. */
const ViewRoot = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

const ConnectedNetwork3DView = connect(
  Network3DView,
  network3dViewModel$(
    VIEW_INSTANCE_ID,
    getViewpointModeViewSettingsWithChanges$(VIEW_ID, VIEW_INSTANCE_ID)
  )
);

export const Network3DViewController = () => (
  <ViewRoot className="prevent-context-change">
    <ConnectedNetwork3DView />
  </ViewRoot>
);
